/*
  Project: Payette.com
  Author: Xfive
 */

import objectFit from './polyfills/object-fit';
import header from './modules/header';
import footer from './modules/footer';
import search from './modules/search';
import sliders from './modules/sliders';
import tiles from './modules/tiles';
import videos from './modules/videos';
import thumbnails from './modules/thumbnails';
import accordions from './modules/accordions';
import buttons from './modules/buttons';
import stats from './modules/stats';
import awardsRows from './modules/awards-rows';
import scrollSpy from './modules/scroll-spy';
import sayHello from './modules/say-hello';

objectFit();
header();
footer();
search();
videos();
tiles();
sliders();
thumbnails();
accordions();
buttons();
stats();
awardsRows();
scrollSpy();
sayHello();

const documentTouchstart = () => {
  document.documentElement.classList.remove('no-touch');
  document.documentElement.classList.add('is-touch');
  document.removeEventListener('touchstart', documentTouchstart);
};

document.addEventListener('touchstart', documentTouchstart);



// WEBPACK FOOTER //
// ./src/scripts/app.js